export const SEARCH_TYPE_ADVERTS = 'adverts'
export const SEARCH_TYPE_AD_WATCHES = 'adWatches'



// WEBPACK FOOTER //
// ./src/components/Arena/constants.js